<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import ProductService from '@/services/product';

moment.locale('pt-BR');

export default {
  page: {
    title: "Listagem de Produtos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Listagem de Produtos",
      loading: false,
      products: [],
      customerPrice: {},

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      fields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'description', sortable: true, label: 'Produto' },
        { key: 'color', sortable: true, label: 'Cor' },
        { key: 'weight', sortable: true, label: 'Peso', formatter: (value) => {
          return (value).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 3 })
        } },
        { key: 'taxes.originalPrice', sortable: true, label: 'R$ Tabela', formatter: (value, key, item) => {
          return (item.taxes.originalPrice).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'taxes.stValue', sortable: true, label: 'R$ ST', formatter: (value, key, item) => {
          return (item.taxes.stValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'taxes.ipiValue', sortable: true, label: 'R$ IPI', formatter: (value, key, item) => {
          return (item.taxes.ipiValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'taxes.totalValue', sortable: true, label: 'R$ Valor', formatter: (value, key, item) => {
          return (item.taxes.totalValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
      ],
    };
  },
  mounted() {
    this.customerPrice = this.$store.getters.customerPrice;
    this.loadPrices();
  },
  methods: {
    loadPrices(page = 1, showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      ProductService.getPrices(page, this.customerPrice.companyId, this.customerPrice.customerId)
        .then(res => {
          this.loading = false;

          this.products = res.data.products;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadPrices(this.currentPage);
    },
    exportData() {
      this.loading = true;

      ProductService.exportPrices(this.customerPrice.companyId, this.customerPrice.customerId).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'ListaDePreco.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="button-search">
              <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar Tabela de Preços</b-button>
              <a href="javascript:void(0);" class="text-primary" v-if="loading">
                <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="products"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>